document.addEventListener('DOMContentLoaded', () => {
  const mainFormWrap = document.querySelector('.m-product-form--main');
  const mainButtonText = document.querySelector('[data-main-atc-price-text]');
  const mainButton = document.querySelector('[data-main-atc-price-button]');

  const stickyButtonText = document.querySelector('[data-atc-price-text]');
  const stickyButton = document.querySelector('[data-atc-price-button]');
  const stickyFormEl = document.querySelector('.sticky-atc-form');

  const toolkitUpsell = document.querySelector('[data-toolkit-upsell]');
  const toolkitToggle = document.querySelector('[data-toolkit-toggle]');

  const stickyNote = document.querySelector('[data-sticky-toolkit-note]');
const desktopMainNote = document.querySelector('[data-main-toolkit-note-desktop]');
const mobileMainNote = document.querySelector('[data-main-toolkit-note-mobile]');

  if (!mainFormWrap) return;

  function formatMoney(cents) {
    return `£${(Number(cents || 0) / 100).toFixed(2)}`;
  }

  function getMainQtyInput() {
    return (
      mainFormWrap.querySelector('input[name="quantity"]') ||
      mainFormWrap.querySelector('.m-qty-input input') ||
      mainFormWrap.querySelector('input[type="number"]')
    );
  }

  function getStickyQtyInput() {
    return (
      document.querySelector('.m-sticky-addtocart input[name="quantity"]') ||
      document.querySelector('.m-sticky-addtocart .m-qty-input input') ||
      document.querySelector('.m-sticky-addtocart input[type="number"]') ||
      document.querySelector('sticky-atc input[name="quantity"]') ||
      document.querySelector('sticky-atc .m-qty-input input') ||
      document.querySelector('sticky-atc input[type="number"]')
    );
  }

  function getMainVariantInput() {
    return (
      mainFormWrap.querySelector('input[name="id"]:not([disabled])') ||
      mainFormWrap.querySelector('input[name="id"]') ||
      mainFormWrap.querySelector('select[name="id"]')
    );
  }

  function getStickyVariantInput() {
    return (
      stickyFormEl?.querySelector('input[name="id"]:not([disabled])') ||
      stickyFormEl?.querySelector('input[name="id"]') ||
      stickyFormEl?.querySelector('select[name="id"]')
    );
  }

  function getVariantData() {
    const jsonEl =
      document.querySelector('.m-sticky-addtocart [type="application/json"]') ||
      document.querySelector('sticky-atc [type="application/json"]');

    if (!jsonEl) return [];

    try {
      return JSON.parse(jsonEl.textContent);
    } catch (e) {
      return [];
    }
  }

  function getCurrentVariantId() {
    const mainVariantId = Number(getMainVariantInput()?.value || 0);
    const stickyVariantId = Number(getStickyVariantInput()?.value || 0);
    return mainVariantId || stickyVariantId || 0;
  }

  function getCurrentVariant() {
    const variantId = getCurrentVariantId();
    if (!variantId) return null;

    const variants = getVariantData();
    return variants.find(v => Number(v.id) === variantId) || null;
  }

  function syncStickyVariantToMain() {
    const stickyInput = getStickyVariantInput();
    const mainInput = getMainVariantInput();

    if (!stickyInput || !mainInput) return;
    if (String(stickyInput.value) === String(mainInput.value)) return;

    stickyInput.value = mainInput.value;
    stickyInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function syncMainVariantToSticky() {
    const stickyInput = getStickyVariantInput();
    const mainInput = getMainVariantInput();

    if (!stickyInput || !mainInput) return;
    if (String(mainInput.value) === String(stickyInput.value)) return;

    mainInput.value = stickyInput.value;
    mainInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function getQty() {
    const mainQtyInput = getMainQtyInput();
    const stickyQtyInput = getStickyQtyInput();
    const qty = Number(mainQtyInput?.value || stickyQtyInput?.value || 1);
    return qty > 0 ? qty : 1;
  }

  function isToolkitSelected() {
    return !!toolkitToggle?.checked;
  }

  function getToolkitVariantId() {
    return Number(toolkitUpsell?.dataset.toolkitVariantId || 0);
  }

  function getToolkitUnitPrice() {
    return Number(toolkitUpsell?.dataset.toolkitPrice || 0);
  }

  function getToolkitTotalPrice() {
    if (!toolkitUpsell || !isToolkitSelected()) return 0;
    return getToolkitUnitPrice() * getQty();
  }

  function updateStickyToolkitNote() {
    if (!stickyNote) return;
    stickyNote.style.display = isToolkitSelected() ? 'block' : 'none';
  }

function updateMainToolkitNote() {
  if (desktopMainNote) {
    desktopMainNote.classList.toggle('is-visible', isToolkitSelected());
  }

  if (mobileMainNote) {
    mobileMainNote.classList.toggle('is-visible', isToolkitSelected());
  }
}

  function updateMainAtcButton() {
    const variant = getCurrentVariant();

    const mainLabel = (window.MinimogStrings && window.MinimogStrings.addToCart)
      ? window.MinimogStrings.addToCart
      : 'Add to cart';

    if (!variant) {
      if (mainButtonText) mainButtonText.textContent = mainLabel;
      if (stickyButtonText) stickyButtonText.textContent = mainLabel;
      return;
    }

    if (!variant.available) {
      const soldOutLabel = window.MinimogStrings?.soldOut || 'Sold out';
      if (mainButtonText) mainButtonText.textContent = soldOutLabel;
      if (stickyButtonText) stickyButtonText.textContent = soldOutLabel;
      return;
    }

    const qty = getQty();
    const mainTotal = Number(variant.price || 0) * qty;
    const toolkitTotal = getToolkitTotalPrice();
    const combinedTotal = mainTotal + toolkitTotal;

    const mainPriceHtml = `
      <span class="frk-main-atc-line">
        ${mainLabel}
        <span data-vat-price data-price-cents="${combinedTotal}">
          ${formatMoney(combinedTotal)}
        </span>
      </span>
    `;

    const stickyPriceHtml = `
      ${mainLabel} ·
      <span data-vat-price data-price-cents="${combinedTotal}">
        ${formatMoney(combinedTotal)}
      </span>
    `;

    if (mainButtonText) {
      mainButtonText.innerHTML = mainPriceHtml;
    }

    if (stickyButtonText) {
      stickyButtonText.innerHTML = stickyPriceHtml;
    }

    if (window.updateVatPrices) window.updateVatPrices();
  }

  function bindQtyInput(input, boundKey, wrapBoundKey) {
    if (!input || input.dataset[boundKey] === 'true') return;

    input.dataset[boundKey] = 'true';

    input.addEventListener('input', () => {
      setTimeout(() => {
        updateMainAtcButton();
        updateStickyToolkitNote();
        updateMainToolkitNote();
      }, 20);
    });

    input.addEventListener('change', () => {
      setTimeout(() => {
        updateMainAtcButton();
        updateStickyToolkitNote();
        updateMainToolkitNote();
      }, 20);
    });

    const qtyWrap = input.closest('.m-qty-input, .m-quantity-input, .m-sticky-addtocart--quantity');
    if (qtyWrap && qtyWrap.dataset[wrapBoundKey] !== 'true') {
      qtyWrap.dataset[wrapBoundKey] = 'true';

      qtyWrap.addEventListener('click', () => {
        setTimeout(() => {
          updateMainAtcButton();
          updateStickyToolkitNote();
          updateMainToolkitNote();
        }, 50);
      });
    }
  }

  function bindQty() {
    bindQtyInput(getMainQtyInput(), 'frkMainAtcBound', 'frkMainAtcWrapBound');
    bindQtyInput(getStickyQtyInput(), 'frkStickyMirrorBound', 'frkStickyMirrorWrapBound');
  }

  function resetQtyAfterAdd() {
    const mainQtyInput = getMainQtyInput();
    const stickyQtyInput = getStickyQtyInput();

    if (mainQtyInput) {
      mainQtyInput.value = 1;
      mainQtyInput.setAttribute('value', '1');
      mainQtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (stickyQtyInput) {
      stickyQtyInput.value = 1;
      stickyQtyInput.setAttribute('value', '1');
      stickyQtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      stickyQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    setTimeout(() => {
      updateMainAtcButton();
      updateStickyToolkitNote();
      updateMainToolkitNote();
    }, 30);

    setTimeout(() => {
      updateMainAtcButton();
      updateStickyToolkitNote();
      updateMainToolkitNote();
    }, 150);

    setTimeout(() => {
      updateMainAtcButton();
      updateStickyToolkitNote();
      updateMainToolkitNote();
    }, 400);
  }

  async function addItemsToCart(items) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items })
    });

    if (!response.ok) {
      throw new Error('Cart add failed');
    }

    return response.json();
  }

async function refreshCartDrawer() {
  document.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true,
    detail: { open: true }
  }));

  setTimeout(() => {
    document.dispatchEvent(new CustomEvent('cart:updated', {
      bubbles: true
    }));

    if (window.updateVatPrices) window.updateVatPrices();
  }, 350);
}

  function getItemsForCart() {
    const variant = getCurrentVariant();
    if (!variant || !variant.available) return null;

    const qty = getQty();
    const items = [
      {
        id: Number(variant.id),
        quantity: qty
      }
    ];

    if (toolkitUpsell && isToolkitSelected()) {
      const toolkitVariantId = getToolkitVariantId();
      if (toolkitVariantId > 0) {
        items.push({
          id: toolkitVariantId,
          quantity: qty
        });
      }
    }

    return items;
  }

  function bindBundleSubmit(formEl, buttonEl, errorRoot = mainFormWrap) {
    if (!formEl || !buttonEl || formEl.dataset.frkBundleBound === 'true') return;
    formEl.dataset.frkBundleBound = 'true';

    formEl.addEventListener('submit', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') {
        e.stopImmediatePropagation();
      }

      const variant = getCurrentVariant();
      if (!variant || !variant.available) return;

      if (buttonEl.classList.contains('is-loading')) return;
      buttonEl.classList.add('is-loading');
      buttonEl.setAttribute('disabled', 'disabled');

      try {
        const items = getItemsForCart();
        if (!items || !items.length) {
          throw new Error('No cart items built');
        }

        console.log('FRK bundle items being added:', items);

        await addItemsToCart(items);
        await refreshCartDrawer();
        resetQtyAfterAdd();
      } catch (error) {
        console.error('FRK bundle add-to-cart failed:', error);

        const messageWrap = errorRoot?.querySelector('.m-product-form-message');
        if (messageWrap) {
          messageWrap.textContent = 'Sorry, there was a problem adding this to cart.';
        }
      } finally {
        buttonEl.classList.remove('is-loading');

        const variantStillAvailable = getCurrentVariant()?.available;
        if (variantStillAvailable) {
          buttonEl.removeAttribute('disabled');
        }

        setTimeout(() => {
          updateMainAtcButton();
          updateStickyToolkitNote();
          updateMainToolkitNote();
        }, 50);
      }
    }, true);
  }

  bindQty();
  syncStickyVariantToMain();
  updateMainAtcButton();
  updateStickyToolkitNote();
  updateMainToolkitNote();

  if (toolkitToggle) {
    toolkitToggle.addEventListener('change', () => {
      setTimeout(() => {
        updateMainAtcButton();
        updateStickyToolkitNote();
        updateMainToolkitNote();
      }, 20);
    });
  }

  const mainVariantInput = getMainVariantInput();
  const stickyVariantInput = getStickyVariantInput();

  if (mainVariantInput) {
    mainVariantInput.addEventListener('change', () => {
      syncStickyVariantToMain();
      setTimeout(() => {
        bindQty();
        updateMainAtcButton();
        updateStickyToolkitNote();
        updateMainToolkitNote();
      }, 30);
    });
  }

  if (stickyVariantInput) {
    stickyVariantInput.addEventListener('change', () => {
      syncMainVariantToSticky();
      setTimeout(() => {
        bindQty();
        updateMainAtcButton();
        updateStickyToolkitNote();
        updateMainToolkitNote();
      }, 30);
    });
  }

  document.addEventListener('change', (e) => {
    if (
      e.target.matches('input[name="id"]') ||
      e.target.matches('select[name="id"]') ||
      e.target.closest('variant-picker')
    ) {
      setTimeout(() => {
        syncStickyVariantToMain();
        bindQty();
        updateMainAtcButton();
        updateStickyToolkitNote();
        updateMainToolkitNote();
      }, 30);
    }
  });

  window.addEventListener('syncProductQuantity', () => {
    setTimeout(() => {
      bindQty();
      updateMainAtcButton();
      updateStickyToolkitNote();
      updateMainToolkitNote();
    }, 20);

    setTimeout(() => {
      bindQty();
      updateMainAtcButton();
      updateStickyToolkitNote();
      updateMainToolkitNote();
    }, 80);
  });

  if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents?.variantChange) {
    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.variantChange, () => {
      setTimeout(() => {
        syncStickyVariantToMain();
        bindQty();
        updateMainAtcButton();
        updateStickyToolkitNote();
        updateMainToolkitNote();
      }, 30);
    });
  }

  const mainFormEl = mainFormWrap.querySelector('form');
  bindBundleSubmit(mainFormEl, mainButton, mainFormWrap);
  bindBundleSubmit(stickyFormEl, stickyButton, mainFormWrap);

  document.addEventListener('cart:updated', resetQtyAfterAdd);
  document.addEventListener('cart:refresh', resetQtyAfterAdd);
});